import axios from "axios";
import { base_url } from "../../../config/config";

/**
 * Fetch all calendar templates
 * @returns {Promise<Array>} Array of templates
 */
export const fetchTemplates = async () => {
  const response = await axios.get(`${base_url}/v1/GetCaledarTemplate`);
  // API returns array directly, not wrapped in { data: [...] }
  if (response.data) {
    return Array.isArray(response.data)
      ? response.data
      : response.data.data || [];
  }
  return [];
};

/**
 * Create a new calendar template (used for copying)
 * @param {Object} payload - Template data { name, processes }
 * @returns {Promise<Object>} Response with new template
 */
export const createTemplate = async (payload) => {
  const response = await axios.post(
    `${base_url}/v1/CreateCaledarTemplate`,
    payload
  );
  return response;
};

/**
 * Delete a template by ID
 * @param {string} templateId - The template ID to delete
 * @returns {Promise<Object>} Response
 */
export const deleteTemplate = async (templateId) => {
  const response = await axios.delete(
    `${base_url}/v1/DeleteTemplate/${templateId}`
  );
  return response;
};
